'use strict';
import { ReadingAssessmentLoader } from './loader';
import { handleLazyLoadError } from '../../helper/error-helper';

var RoutePath = require('../../constants/routePath');
var ModuleAccessCodes = require('../../constants/moduleCodes');

var routerUtility = require('../../utils/routerUtility');
var getRaUrl = require('./getUrls');

module.exports = {
  path: getRaUrl.getRaModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, {
        component: require('../../component/homePage'),
      }, 'reading-assessment')
    })
  },

  getComponent(nextState, callback) {
    var error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_RA);
    if (error === null) {
      ReadingAssessmentLoader.load(callback).catch(handleLazyLoadError);
    } else {
      callback(error);
    }
  },

  getChildRoutes(partialNextState, callback) {
    require.ensure([], function (require) {
        callback(null, [
          {
            path: RoutePath.ROUTE_RA_LATEST_ASSESSMENTS,
            component: require('../../component/recentSessions/recentSessionsPage')
          },
          {
            path: RoutePath.ROUTE_RA_LEARNERS_PORTFOLIOS,
            component: require('../../component/learnersPortfolio/learnersPortfolioPage')
          },
          {
            path: RoutePath.ROUTE_RA_LEARNER_PORTFOLIO,
            component: require('../../component/recentSessions/recentSessionsPage')
          },
          {
            path: RoutePath.ROUTE_RA_REPORTS,
            component: require('../../component/reports/reports')
          },
          {
            path: RoutePath.ROUTE_MY_PROFILE,
            component: require('../../component/profile/profilePage')
          },
          {
            path: RoutePath.ROUTE_NOT_FOUND,
            component: require('../../component/errors/notFoundPage')
          }
        ])
      },
      handleLazyLoadError,
      'reading-assessment');
  }
};
